import { NewsWrapper } from "../../../../src/collections/news/News.style.js";
import layer5_hashicorp_partnership from "../../../../src/collections/news/2020/2020-05-28-layer5-and-hasicorp-launch-service-mesh-partnership/Layer5-HashiCorp-Service-Mesh-Partnership.webp";
import layer5_image_hub from "../../../../src/collections/news/2020/2020-05-28-layer5-and-hasicorp-launch-service-mesh-partnership/layer5-image-hub-on-hashicorp-consul.webp";
import * as React from 'react';
export default {
  NewsWrapper,
  layer5_hashicorp_partnership,
  layer5_image_hub,
  React
};